import module from 'fan/proyecto/module.js'
import template from './template.html'

const catalogos = {
  fuentes: [
    {id: 'calibri', descripcion: 'Calibri 10pt'},
    {id: 'arial', descripcion: 'Arial 10pt'},
  ],
  margenes: [
    {id: 'estrecho', descripcion: 'Estrecho (1.25 cm)'},
    {id: 'moderado', descripcion: 'Moderado (2.00 cm)'},
    {id: 'normal', descripcion: 'Normal (2.50 cm)'},
  ],
  tipoPlantilla: [
    {id: 1, descripcion: 'Colaborador'},
  ],
}

export class FanProyectoDocumentosPlantillasAgregarGuardarComponent {
  constructor (FanProyectoDocumentosPlantillasService, $q) {
    this.$q = $q
    this.FanProyectoDocumentosPlantillasService = FanProyectoDocumentosPlantillasService
    this.idProyecto = undefined
    this.data = undefined
    this.onClose = undefined
    this.error = null
    this.procesando = false
    this.resultado = null
    this.validacion = {
      valido: (nombre) => {
        if (!nombre) return this.$q.resolve()

        let array = nombre.split('/')

        if (array[array.length - 1]) {
         return this.$q.resolve()
        } else {
         return this.$q.reject()
        }
      },
    }

    this.catalogos = catalogos
  }

  $onInit () {
    this.data.documento_titulo = this.data.documento_titulo || this.data.nombre || ''
    this.data.archivo_nombre = this.data.archivo_nombre || this.data.nombre || ''
  }

  guardar () {
    if (this.procesando || this.resultado) return

    this.error = null
    this.procesando = true

    let ruta = this.data.nombre.split('/')
    this.data.nombre = ruta.splice(ruta.length - 1, 1)[0]
    if (this.data.nombre === '') {
      return
    }

    let diagonal = ruta[0] ? '/' : ''
    this.data.ruta = `${diagonal}${ruta.join('/')}/`

    this.FanProyectoDocumentosPlantillasService.post(this.idProyecto, this.data)
      .then((response) => (this.resultado = response.data))
      .catch((response) => (this.error = response.data))
      .finally(() => (this.procesando = false))
  }

  cerrar () {
    this.onClose({$event: {data: this.resultado}})
  }

  validarEncabezado () {
    if (this.data.documento_margenes_encabezado === 0) {
      this.data.documento_logotipo = false
    }
  }

  cambioNombre () {
    this.data.documento_titulo = this.data.documento_titulo || this.data.nombre
    this.data.archivo_nombre = this.data.archivo_nombre || this.data.nombre
  }

  sanitizar (string) {
    return string ? string.replace(/[^\x20-\x7E]+/g, '') : string
  }
}

module.component('fanProyectoDocumentosPlantillasAgregarGuardar', {
  template,
  controller: FanProyectoDocumentosPlantillasAgregarGuardarComponent,
  bindings: {
    idProyecto: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/documentos/plantillas/agregar/guardar/component.js